const objectKeysIntersection = (obj1, dataObj) => {
    /* will take two objects and return the intersection of first layer keys

    input:
    - obj1 - the object to act as a 'mask' - used for its keys only
    - dataObj - if this objects keys are also keys of obj1, will return values for this
    */
    const outObj = {};
    const keys1 = Object.keys(obj1);
    Object.entries(dataObj).forEach(([key, value]) => {
        if (keys1.includes(key)) {
            outObj[key] = value;
        }
    });
    return outObj;
};

export default objectKeysIntersection;
